import {
  ADD_TO_FAVORITES,
  REMOVE_FROM_FAVORITES
} from "../actions/activityActions"

const initialState = {
  favoriteActivityIds: checkLocalStorage(),
  allCategories: [
    { name: "Праздник", slug: "holiday" },
    { name: "Фестиваль", slug: "festival" },
    { name: "Шоу", slug: "show" },
    { name: "Мюзикл", slug: "musical" },
    { name: "Выставка", slug: "exhibition" }
  ],
  activityData: [
    {
      id: 1,
      title: "Фестиваль света",
      slug: "razdnik-festival-sveta",
      description:
        "Этой зимой, горожан и гостей города приглашает Музей Магии. Музей Магии — это целое волшебное пространство, в котором найдётся много интересного как для детей, так и для взрослых. Большинство экспонатов музея — это интерактивные объекты, в которых вы сможете воспроизвести известные фокусы.   Источник — kuda-spb.ru, лучшие события Санкт-Петербурга.",
      image: null,
      body:
        "4 и 5 ноября в Петербурге пройдёт очередной Фестиваль света. На этот раз действо захватит сразу две площадки — Дворцовую площадь и Петроградскую набережную.\nНа фасады Зимнего дворца и Главного штаба будут транслировать 3D-представление с использованием технологии видеомэппинга, лазерных и пиротехнических эффектов. На стенах штаба зрители увидят спектакль о ключевых моментах 1917 года, причём здание будет принимать облик то Путиловского завода, то особняка Матильды Кшесинской, то Александринского театра. На Зимнем дворце тем временем появятся картины, воспевающие Петербург. Здесь будет всё, что дорого каждому горожанину: мосты, львы и сфинксы, дворы-колодцы, белые ночи и другие символы Северной столицы.\nВ этом году на Дворцовой площади впервые пройдёт конкурс мастеров видео-арта..",
      price: null,
      is_free: true,
      categories: ["holiday", "festival"]
    },
    {
      id: 2,
      title: "Шоу фокусников и бесплатные экскурсии в Музее Магии",
      slug: "shou-fokusnikov",
      description:
        "Петербург славится своими культурными традициями, и одна из них зарождается прямо на наших глазах — это Фестиваль света. Праздник проходит второй год подряд и привлекает тысячи зрителей. В этот раз темой стал юбилей Октябрьской революции.",
      image: null,
      body:
        "Каждый посетитель пройдет по музею в сопровождении экскурсовода и узнает много интересного о мире магии. На территории музея построена сцена — где опытный иллюзионист каждый час показывает шоу для всех посетителей музея. Яркие впечатления гарантированы! Каждый сантиметр Музея Магии открыт для фотографирования — сложно уйти без набора необычных снимков и селфи. Ожившие картины, волшебная шляпа и стул для левитации ждут вас!   Источник — kuda-spb.ru, лучшие события Санкт-Петербурга.",
      price: 1500,
      is_free: false,
      categories: ["show"]
    },
    {
      id: 3,
      title: "Зима в Океанариуме",
      slug: "zima",
      description:
        "Этой зимой Вас приглашает Океанариум — «подводный музей» с живыми экспонатами — обитателями водной среды. Билеты в конце анонса.",
      image: null,
      body:
        "В Океанариуме каждый посетитель может не только погрузиться в атмосферу волшебного окружения подводного мира, но и стать свидетелем ежедневных (кроме понедельника) эксклюзивных шоу с водными обитателями — «Шоу с акулами» и «Шоу с тюленями»   Источник — kuda-spb.ru, лучшие события Санкт-Петербурга.",
      price: 5500,
      is_free: false,
      categories: ["holiday", "show"]
    },
    {
      id: 4,
      title: "Мюзикла «Великий Гэтсби»",
      slug: "velikij-gtsbi",
      description:
        "24 января 2020 года, на сцене Мюзик-Холла, пройдет премьера мюзикла  «Великий Гэтсби». Новое прочтение культового романа Ф. С. Фицджеральда поднимает важнейший круг тем и проблем. Это тема любви и одиночества, проблема настоящих и мнимых ценностей, гибели идеалов и надежд человека в современном мире. Билеты в конце анонса.   Источник — kuda-spb.ru, лучшие события Санкт-Петербурга.",
      image: null,
      body:
        "Популярный роман неоднократно привлекал внимание кинематографистов и театральных режиссеров. Театр «Мюзик-Холл» впервые в России представил историю американской мечты и ее краха в жанре мюзикла. Зрителей ждет феерия музыки и танцев: гремучий микс 1920-ых гг., неподражаемая эпоха ар-деко и безудержного веселья, граничащего с фатальной безрассудностью.   Источник — kuda-spb.ru, лучшие события Санкт-Петербурга.",
      price: 10500,
      is_free: false,
      categories: ["musical", "show"]
    },
    {
      id: 5,
      title: "Выставка «Развлечение для попавших в штиль»",
      slug: "vystavka",
      description:
        "С 15 по 29 января 2020 года, в музее Анны Ахматовой в Фонтанном доме, проходит выставка «Развлечение для попавших в штиль». Выставку работ петербургского художника Игоря Александрова составили произведения последних лет.   Источник — kuda-spb.ru, лучшие события Санкт-Петербурга.",
      image: null,
      body:
        "Чтобы усилить впечатление иллюзорности, театрализованности, автор выбрал стиль афиши. Художник работает в ахроматической гамме: черно-белая палитра позволяет создавать образ скупыми и одновременно изысканности средствами. Игорь Александров родился в 1978 году в Ленинграде. Получил музыкальное образование, в 22 года начал пробовать себя в живописи. Окончив вечерние рисовальные классы при Академии художеств, пошел не проторенной дорогой, а, по словам самого художника, «полез своей тропой в некие дебри, свет сквозь которые не видел, но скорее чувствовал».   Источник — kuda-spb.ru, лучшие события Санкт-Петербурга.",
      price: 28000,
      is_free: false,
      categories: ["exhibition"]
    },
    {
      id: 6,
      title: "Выставка «Мадонна в цветах»",
      slug: "vystavka-madonna",
      description:
        "С 12 декабря по 23 февраля 2020 г. в Arts Square Gallery проходит выставка «Мадонна в цветах», на которой зрители увидят уникальные полотна фламандских художников XVII века Питера Пауля Рубенса, Яна Брейгеля старшего и Яна Брейгеля младшего, Эразмуса Квеллинуса, Яна Филипса ван Тилена и Корнелиса ван Клеве из частных собраний. Картины представляют собой богато декорированные цветами композиции на сюжеты Нового Завета. Билеты в конце анонса.   Источник — kuda-spb.ru, лучшие события Санкт-Петербурга.",
      image: null,
      body:
        "Голландия, XVII столетие. Страна переживает небывалый расцвет, так называемый «Золотой век». В конце XVI века несколько провинций страны добились независимости от Испании. Теперь протестантские Нидерланды пошли своим путем, а католическая Фландрия (нынешняя Бельгия) под крылом Испании — своим. Семнадцатое столетие фламандской живописи до сих пор поражает нас богатством своих достижений, в том числе исключительным разнообразием картин на религиозные темы. Достоверность деталей и выверенная до мелочей композиция были отличительными признаками живописи этого периода.   Источник — kuda-spb.ru, лучшие события Санкт-Петербурга.",
      price: null,
      is_free: true,
      categories: ["exhibition"]
    }
  ]
}

export const activityReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_FAVORITES:
      updateLocalStorage(action.payload)
      return {
        ...state,
        favoriteActivityIds: [...state.favoriteActivityIds, action.payload]
      }

    case REMOVE_FROM_FAVORITES:
      updateLocalStorage(action.payload)
      let sameId = state.favoriteActivityIds.indexOf(action.payload)
      let before = state.favoriteActivityIds.slice(0, sameId)
      let after = state.favoriteActivityIds.slice(sameId + 1)
      let newArray = [...before, ...after]
      return {
        ...state,
        favoriteActivityIds: newArray
      }

    default:
      return state
  }
}

function updateLocalStorage(id) {
  let newArray = checkLocalStorage()
  let sameId = newArray.indexOf(id)

  if (sameId >= 0) {
    newArray.splice(sameId, 1)
  } else {
    newArray.push(id)
  }

  localStorage.setItem("favoritesActivityIds", JSON.stringify(newArray))
}

function checkLocalStorage() {
  if (!localStorage["favoritesActivityIds"]) {
    return []
  }
  return JSON.parse(localStorage.getItem("favoritesActivityIds"))
}
